'use client';

import { useEffect, useMemo } from 'react';
import { CampaignsServerData } from '@/app/(activity)/campaigns/[slug]/types';
import CampaignBanner from '../../components/CampaignBanner';
import SeedingItemList from './components/SeedingItemList';
import { useSeedingTracking } from './hooks/useSeedingTracking';

interface SeedingPageProps {
  serverData: CampaignsServerData;
  isAppCommunicationReady: boolean;
  /** 种草列表全部分页加载完成后回调（用于展示活动页公共底部模块） */
  onBottomContentReady?: () => void;
}

export default function SeedingPage({
  serverData,
  isAppCommunicationReady,
  onBottomContentReady,
}: SeedingPageProps) {
  const { trackPageView, trackPageLeave } = useSeedingTracking(serverData.runtimeConfig);

  useEffect(() => {
    trackPageView();
  }, [trackPageView]);

  useEffect(() => {
    return () => {
      trackPageLeave();
    };
  }, [trackPageLeave]);

  const bannerProps = useMemo(() => {
    if (!serverData.bannerData) return null;

    return {
      data: {
        image: serverData.bannerData.image,
        image_alt: serverData.bannerData.image_alt,
        type: serverData.bannerData.type,
        jump_content: serverData.bannerData.jump_content,
      },
      aspectRatio: serverData.bannerData.aspectRatio,
    };
  }, [serverData.bannerData]);

  const marketingPageId = serverData.runtimeConfig.marketing_page_id || 0;

  return (
    <>
      {bannerProps && (
        <CampaignBanner data={bannerProps.data} aspectRatio={bannerProps.aspectRatio} />
      )}

      {marketingPageId > 0 && (
        <SeedingItemList
          marketingPageId={marketingPageId}
          isPreview={serverData.isPreview}
          deviceType={serverData.deviceType}
          runtimeConfig={serverData.runtimeConfig}
          initialData={serverData.seedingItems}
          isAppCommunicationReady={isAppCommunicationReady}
          onSeedingFullyLoaded={onBottomContentReady}
          adp={serverData.adp}
        />
      )}
    </>
  );
}
